import {Injectable} from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [

  {
    label: 'Admin Dashboard',
    main: [
      {
        state: 'dashboard',
        sub_state:null,
        short_label: 'F',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-home'
      },
      // {
      //   state: 'booking',
      //   sub_state:'list',
      //   short_label: 'F',
      //   name: 'Booking List',
      //   type: 'link',
      //   icon: 'ti-menu-alt'
      // },
      // {
      //   state: 'trainer',
      //   sub_state:'list',
      //   short_label: 'F',
      //   name: 'Trainer',
      //   type: 'link',
      //   icon: 'ti-crown'
      // },
      // {
      //   state: 'role',
      //   sub_state:'add',
      //   short_label: 'F',
      //   name: 'Add New Role',
      //   type: 'link',
      //   icon: 'ti-layers'
      // },
      {
        state: 'content',
        sub_state:'list',
        short_label: 'F',
        name: 'Banner / Article / Notifs',
        type: 'link',
        icon: 'ti-pencil'
      },
      {
        state: 'privilege',
        sub_state:'list',
        short_label: 'P',
        name: 'Privileges',
        type: 'link',
        icon: 'ti-pencil'
      },
      {
        state: 'exercise',
        sub_state:'list',
        short_label: 'E',
        name: 'Exercises',
        type: 'link',
        icon: 'ti-pulse'
      },
      // {
      //   state: 'trainer',
      //   sub_state:'rating-review',
      //   short_label: 'F',
      //   name: ' Rating & Review ',
      //   type: 'link',
      //   icon: 'ti-star'
      // },
      // {
      //   state: 'admin',
      //   sub_state: 'list',
      //   short_label: 'F',
      //   name: 'Admin',
      //   type: 'link',
      //   icon: 'ti-id-badge'
      // },
      // {
      //   state: 'category',
      //   sub_state: 'list',
      //   short_label: 'F',
      //   name: 'Category',
      //   type: 'link',
      //   icon: 'ti-medall'
      // },
      // {
      //   state: 'speciality',
      //   sub_state: 'list',
      //   short_label: 'F',
      //   name: 'Trainer Speciality',
      //   type: 'link',
      //   icon: 'ti-medall'
      // },
      // {
      //   state: 'voucher',
      //   sub_state: 'list',
      //   short_label: 'F',
      //   name: 'Voucher',
      //   type: 'link',
      //   icon: 'ti-ticket'
      // },
      // {
      //   state: 'event',
      //   sub_state: 'list',
      //   short_label: 'F',
      //   name: 'Event',
      //   type: 'link',
      //   icon: 'ti-bookmark'
      // },
      {
        state: 'webinar',
        sub_state: 'list',
        short_label: 'W',
        name: 'Webinar',
        type: 'link',
        icon: 'ti-video-camera'
      },
      {
        state: 'body-composition',
        sub_state: 'list',
        short_label: 'F',
        name: 'Body Composition',
        type: 'link',
        icon: 'ti-bookmark'
      },
      {
        state: 'company',
        sub_state: 'list',
        short_label: 'F',
        name: 'B2B Company / Clients',
        type: 'link',
        icon: 'ti-bookmark'
      },
      {
        state: 'b2b-event',
        sub_state: 'list',
        short_label: 'F',
        name: 'B2B Program',
        type: 'link',
        icon: 'ti-bookmark'
      },
      {
        state: 'b2b-group',
        sub_state: 'list',
        short_label: 'F',
        name: 'B2B Program Grouping',
        type: 'link',
        icon: 'ti-bookmark'
      },
      // {
      //   state: 'b2b-training-attendance',
      //   sub_state: 'list',
      //   short_label: 'F',
      //   name: 'B2B Training Attendance',
      //   type: 'link',
      //   icon: 'ti-bookmark'
      // },
      // {
      //   state: 'b2b-report-biweekly',
      //   sub_state: 'list',
      //   short_label: 'F',
      //   name: 'B2B Report Biweekly',
      //   type: 'link',
      //   icon: 'ti-bookmark'
      // },
      // {
      //   state: 'b2b-report-wellness-performance',
      //   sub_state: 'list',
      //   short_label: 'F',
      //   name: 'B2B Report Wellness',
      //   type: 'link',
      //   icon: 'ti-book'
      // },
      {
        state: 'nutritionist',
        sub_state: 'list',
        short_label: 'F',
        name: 'Nutritionist',
        type: 'link',
        icon: 'ti-bookmark'
      },
      {
        state: 'client-exclusive',
        sub_state: 'list',
        short_label: 'CE',
        name: 'Client Exclusive',
        type: 'link',
        icon: 'ti-user'
      },
      {
        state: 'users',
        sub_state:'list',
        short_label: 'F',
        name: 'All Users',
        type: 'link',
        icon: 'ti-user'
      },
    ]
  }
];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }

  /*add(menu: Menu) {
    MENUITEMS.push(menu);
  }*/
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/PROD-mufit-web/src/app/shared/menu-items/menu-items.ts